import Component from '@glimmer/component';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class UserBadgeInner extends Component {
  PersonType = PersonType;
}
